export default __webpack_public_path__ + "static/media/answer_question_2.e7236684.svg";